import SimplePagination from "PFComponents/pagination/simple_pagination";
import Table from "PFComponents/table";
import { useLocalisationKeys } from "PFCore/hooks/queries/admin/localisation";
import { LocalisationKeys } from "PFTypes";
import { Account } from "PFTypes/account";
import React, { useState } from "react";

import { useColumnsGenerator } from "./use_columns_generator";

type LocalisationKeysListProps = {
  account?: Account;
  localisationKey: LocalisationKeys;
};

export const LocalisationKeysList = ({ account, localisationKey }: LocalisationKeysListProps) => {
  const [page, setPage] = useState(1);

  const { data } = useLocalisationKeys(account?.id || 0, localisationKey, page, {
    enabled: !!account?.id
  });

  const generateColumns = useColumnsGenerator(account?.id || 0, localisationKey);

  return (
    <>
      <Table tableData={data?.entries || []} generateColumns={generateColumns} />
      <SimplePagination currentPage={page} handleClick={setPage} totalPages={data?.meta.totalPages} />
    </>
  );
};
